import { LinkButton } from '@cian/ui-kit/button';
import { FC } from 'react';

import { MAX_COMMUNITY_URL, TELEGRAM_CHANNEL_URL } from 'shared/containers/Superhost/const';

import style from './Contest.css';
import { useDeviceType } from '@cian/ui-kit';
import { IconSocialMax24, IconSocialTelegram24 } from '@cian/ui-kit-design-tokens/icons';

export const Contest: FC = () => {
  const isMobile = useDeviceType() === 'phone';

  return (
    <section className={style['section']}>
      <div className={style['inner']}>
        <div className={style['banner']}>
          <p className={style['text']}>
            <span className={style['text-bold']}>Участвуйте в конкурсе для Суперхозяев&nbsp;</span>и&nbsp;выигрывайте
            ценные призы&nbsp;в&nbsp;сообществе хостов
          </p>
          <div className={style['buttons']}>
            <LinkButton
              href={MAX_COMMUNITY_URL}
              theme="fill_secondary"
              size="L"
              beforeIcon={<IconSocialMax24 color="icon-main-default" />}
              fullWidth={isMobile}
            >
              В Max
            </LinkButton>
            <LinkButton
              href={TELEGRAM_CHANNEL_URL}
              theme="fill_secondary"
              size="L"
              beforeIcon={<IconSocialTelegram24 color="icon-main-default" />}
              fullWidth={isMobile}
            >
              В Telegram
            </LinkButton>
          </div>
        </div>
      </div>
    </section>
  );
};
